module.exports = __webpack_public_path__ + "img/nopass.2394d67f.png";